import {jsonMember, jsonObject} from "typedjson";
import {DxUser} from "./dx-user";
import {DxUserRole} from "./dx-user-role";

@jsonObject
export class DxKeycloakUser extends DxUser {
  // login
  @jsonMember({name: "preferred_username", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _login: string;

  // first_name
  @jsonMember({name: "given_name", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _firstName: string;

  // last_name
  @jsonMember({name: "family_name", constructor: String, emitDefaultValue: true, isRequired: false})
  protected _lastName: string;

  // access token expire time
  @jsonMember({name: "exp", constructor: Number, emitDefaultValue: false, isRequired: false})
  protected _tokenExpTime: number;

  // access token
  private _token: string;

  // refresh token expire time
  private _refreshTokenExpTime: number;

  /** RefreshToken - токен для получения нового токена **/
  private _refreshToken: string;

  // user roles
  private  _roles: DxUserRole[];

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
  }

  get tokenExpTime(): number {
    return this._tokenExpTime;
  }

  set tokenExpTime(value: number) {
    this._tokenExpTime = value;
  }

  get refreshToken(): string {
    return this._refreshToken;
  }

  set refreshToken(value: string) {
    this._refreshToken = value;
  }

  get refreshTokenExpTime(): number {
    return this._refreshTokenExpTime;
  }

  set refreshTokenExpTime(value: number) {
    this._refreshTokenExpTime = value;
  }

  get login(): string {
    return this._login;
  }

  set login(value: string) {
    this._login = value;
  }

  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get roles(): DxUserRole[] {
    return this._roles;
  }

  set roles(value: DxUserRole[]) {
    this._roles = value;
  }

  get fullName(): string {
    // если у пользователя не заданы имя и фамилия, то возвращаем логин
    return (this._firstName && this._lastName) ? (this._firstName + ' ' + this._lastName) : this._login;
  }

}
